import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../core/net';
import { ArchiveModal } from './action-types';
import { commonEnums, HttpMethods } from '@codametrix/ui-common';
import { cmxDateTime, AmplifyCore } from '@codametrix/ui-common';
const { paginationUtils } = AmplifyCore;
const { DictionaryStatus, FilterTypes } = commonEnums;
export const toggleArchiveModal = createAction(ArchiveModal.TOGGLE_ARCHIVE_MODAL);
export const savePotentialArchives = createAction(ArchiveModal.SAVE_POTENTIAL_ARCHIVES);
/**
 * When selecting a row to archive, we give the user the option to also archive the rows in the same dictionary at child organizations.
 * Therefore we recursivley search for the dictionary by name for each org, then we look for the specific row in each dictionary
 **/ export const selectArchiveRow = createAsyncThunk(ArchiveModal.SELECT_ARCHIVE_ROW, async (rowId, { dispatch })=>{
    dispatch(toggleArchiveModal(true));
    const row = await api({
        endpoint: `/dictionary/row/${rowId}/v2`
    });
    const orgChildrenParams = new URLSearchParams({
        tenantId: row.tenantId.uuid
    });
    const orgs = await api({
        endpoint: `/organization/children/v1?${orgChildrenParams.toString()}`
    });
    const defaultDictionaryParams = {
        derivedIndicator: 'false',
        effectiveDateStr: row.effectiveDate || cmxDateTime.format(new Date(), cmxDateTime.FORMATS.DATE)
    };
    const dictionaryQueries = orgs.map((org)=>{
        const dictionarySearchParams = new URLSearchParams({
            ...defaultDictionaryParams,
            tenantId: org.tenantId
        });
        return api({
            endpoint: `/dictionary/${row.dictionaryName}/v2?${dictionarySearchParams.toString()}`
        }).catch(()=>undefined);
    });
    const [...dictionaries] = await Promise.all(dictionaryQueries);
    const keyCell = row.cells.find((cell)=>cell.columnDefinition.keyColumnIndicator);
    const defaultRowParams = new URLSearchParams({
        page: '0',
        size: '25',
        listType: 'column'
    });
    const rowBody = [
        {
            key: 'status',
            terms: [
                DictionaryStatus.PUBLISHED
            ],
            type: FilterTypes.IN
        },
        {
            key: keyCell?.columnDefinition.name,
            terms: [
                keyCell?.value
            ],
            type: FilterTypes.LIKE
        }
    ];
    const removeNulls = (value)=>value != null;
    const rowQueries = dictionaries.filter(removeNulls).map((dict)=>{
        return api({
            endpoint: `/dictionary/${dict.id}/row/v2?${defaultRowParams.toString()}`,
            init: {
                method: HttpMethods.POST
            },
            body: rowBody
        }).catch(()=>paginationUtils.emptyPageable);
    });
    // const rowQueries = retriveRowData(dictionaries,removeNulls,defaultRowParams,rowBody);
    const [...potentialArchives] = await Promise.all(rowQueries);
    // We can return rows[0] since we are looking for a value match in the key column, which is unique.
    dispatch(savePotentialArchives(potentialArchives.filter((rows)=>rows.numberOfElements).map((rows)=>rows.content[0])));
    return row;
});
